import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    fontSize: 20,
    color: theme.palette.text.primary
  }
}))
